import React from "react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/pro-regular-svg-icons";

import "./index.scss";
import { getImageAndVideoFileTypes } from "../../../../util/common";

const ImageGallery = ({ lettersMap, t }) => {
  if (!Array.isArray(lettersMap)) return null;

  const urls = Object.keys(lettersMap);

  if (!urls.length) return null;

  return (
    <div className="images-container">
      {urls.map(url => (
        <div key={url} className="image-container">
          <div className="img-label">
            <div className="img-icon-wrapper">
              <FontAwesomeIcon className="image-video-icon" icon={faCamera} />
              <span className="report-car-images-letter">{lettersMap[url]}</span>
            </div>
          </div>
          <img alt="" className="image-style" src={url} />
        </div>
      ))}
    </div>
  );
};

const TranslatedImageGallery = withTranslation()(ImageGallery);

TranslatedImageGallery.getLettersMap = (fixedItems, notFixedItems, workingItems) => {
  let map = [];
  let currentLetter = 97;
  let currentNumber = 1;

  const setLetter = url => {
    if (currentLetter < 123) {
      map[url] = String.fromCharCode(currentLetter);
      currentLetter++;
    } else {
      map[url] = currentNumber;
      currentNumber++;
    }
  };

  fixedItems.forEach(i => {
    const { images } = getImageAndVideoFileTypes(i.attachments);
    if (Array.isArray(images)) {
      images.forEach(img => {
        setLetter(img.url);
      });
    }
  });

  notFixedItems.forEach(i => {
    const { images } = getImageAndVideoFileTypes(i.attachments);
    if (Array.isArray(images)) {
      images.forEach(img => {
        setLetter(img.url);
      });
    }
  });

  workingItems.forEach(i => {
    if (Array.isArray(i.images)) {
      i.images.forEach(img => {
        setLetter(img.url);
      });
    }
  });

  return map;
};

export default TranslatedImageGallery;
